import {Component, OnInit, ViewChild} from '@angular/core';
import {HrService} from '../hr.service';
import {Employee} from '../../admin/models/employee.model';
import {FormControl, NgForm} from '@angular/forms';
import {FabMessageService} from '@fabric/components/message';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PersonalService} from '../../personal/personal.service';
import {AuthenticationService} from '../../core/authentication/authentication.service';
import {ManagerService} from '../../manager/manager.service';
import {SelectionModel} from '@angular/cdk/collections';
import {AdUser} from '../../admin/models/ad-user';
import {MatTableDataSource} from '@angular/material/table';
import {FabThemeService} from '@fabric/components/theme';
import {UserService} from '../../core/user/user.service';
import {VacationTrackerUser} from '../../core/user/vacation-tracker-user';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-new-employee-pop-up',
    templateUrl: './new-employee-pop-up.component.html',
    styleUrls: ['./new-employee-pop-up.component.scss']
})
export class NewEmployeePopUpComponent implements OnInit {

    public employee = {} as Employee;
    public teamData = {} as any;
    public gminValue: string = '';
    public listOfTeamName: string[] = [];
    public getTeamID = new Map<string, string>();
    public getTeamName = new Map<string, string>();
    public selection = new SelectionModel<AdUser>(true, []);
    public peopleSearchResults: any [] = [];
    public selectedPerson: any;
    public searchSubscription: any;
    public model = {} as Employee;
    public newUser: any;
    public people: AdUser[] = [];
    public user = {} as VacationTrackerUser;
    public dataSource = new MatTableDataSource<AdUser>(this.people);
    public populateFormData = {} as AdUser;
    public contractTypes = [
        {value: 'FULL_TIME_PERMANENT', displayValue: 'Full Time Permanent'},
        {value: 'INTERN', displayValue: 'Intern'},
        {value: 'FIXED_TERM', displayValue: 'Fixed Term'}];
    public roles = [
        {value: 'ABT_HR', displayValue: 'HR'},
        {value: 'ABT_MANAGER', displayValue: 'Manager'},
        {value: 'ABT_EMPLOYEE', displayValue: 'Employee'}];
    public role = {} as any;
    public date = new FormControl(new Date());
    public isPageLoading = false;
    public searchedByUser = false;

    @ViewChild('form') private readonly form!: NgForm;

    constructor(
        private readonly hrService: HrService,
        private readonly userService: UserService,
        private readonly messageService: FabMessageService,
        private readonly dialog: MatDialog,
        public readonly themeService: FabThemeService,
        private readonly fabMessageService: FabMessageService,
        private readonly personalService: PersonalService,
        private readonly managerService: ManagerService,
        private readonly authService: AuthenticationService,
        public dialogRef: MatDialogRef<[]>) {
    }

    ngOnInit(): void {
        this.gminValue = this.authService.userInfo.gmin || '';
        this.hrService.getTeams().subscribe({
            next: (data) => {
                this.teamData = data;
                this.getListOfTeamId();
            }
        });
        this.user.roles = [this.roles[2].value];
    }

    /**
     * Sets the employee dateStarted from the formControl object
     */
    public setModelDate() {
        this.employee.dateStarted = this.date.value!.toString();
        this.employee.dateStarted = this.personalService.convertDateFormatForAPI(this.employee.dateStarted);
    }

    /**
     * Submits the form to create a new employee.
     * Uses people search to find an employee and populate the form.
     */
    submitForm(): void {
        this.setModelDate();
        this.employee.updatedBy = this.gminValue;
        this.role = this.user.roles;

        this.employee.firstName = this.selectedPerson.firstName;
        this.employee.lastName = this.selectedPerson.lastName;
        this.employee.region = this.selectedPerson.country;

        this.employee.emailAddress = this.selectedPerson.email;
        this.employee.gmin = this.selectedPerson.gmin;
        this.employee.location = this.selectedPerson.siteName;

        this.employee.employeeWorkAbroadAllowance = [];
        this.isPageLoading = true;

        this.hrService.saveEmployee(this.employee, this.role).subscribe({
            next: () => {
                this.fabMessageService.displayMessage('Request submitted successfully');
                this.isPageLoading = false;
                this.close();
            }, error: (err: HttpErrorResponse) => {
                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                this.isPageLoading = false;
            }
        });
    }

    /**
     * Gets a list of team ids
     */
    public getListOfTeamId() {
        this.teamData.forEach((value: any) => {
            this.listOfTeamName.push(value.teamName);
            this.getTeamID.set(value.teamName, value.id);
            this.getTeamName.set(value.id, value.teamName);
        });
        this.listOfTeamName = this.managerService.getUniqueValues(this.listOfTeamName);
    }

    /**
     * Closes the popup
     */
    close(): void {
        this.dialogRef.close();
    }

    /**
     * This will call the search method once the user has populated
     * the search box with 4 characters.
     */
    onAddMemberChanged() {
        this.selectedPerson = undefined;
        const minimumLengthToSearch = 3;
        if (this.newUser.length < minimumLengthToSearch) {
            this.peopleSearchResults = [];
            this.isPageLoading = false;
        }
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
        }
        if (this.newUser.length > minimumLengthToSearch) {
            this.search();
        }
    }

    /**
     * This uses the result of the search function to
     * populate the form with the persons details.
     * @param person the person to populate the form
     */
    personSelected(person: any) {
        this.newUser = (person.displayName);
        this.peopleSearchResults = [];
        this.selectedPerson = person;
        this.populateFormData.gmin = this.selectedPerson.gmin;
        this.populateFormData.firstName = this.selectedPerson.firstName;
        this.populateFormData.lastName = this.selectedPerson.lastName;
        this.populateFormData.email = this.selectedPerson.email;
        this.populateFormData.country = this.selectedPerson.country;
        this.searchedByUser = true;
    }

    /**
     * makes a call to a method in the hr service to get photo Url
     * @param userGmin id used to locate photo
     */
    getPhoto(userGmin: string): string {
        return this.hrService.getPhotoUrl(userGmin);
    }

    /**
     * makes a call to a method in the hr service to display the default image
     * @param event onclick or keyup
     */
    displayDefaultImage(event: any) {
        this.hrService.displayDefaultImage(event);
    }

    /**
     * Calls the search for employees method in the hr service
     * returns an error response if it is not working
     * @private
     */
    private search() {
        this.isPageLoading = true;
        this.searchSubscription = this.hrService.searchForEmployees(this.newUser).subscribe({
            next: response => {
                if (response.body !== null) {
                    this.peopleSearchResults = response.body;
                }
                this.isPageLoading = false;
            },
            error: () => {
                this.messageService.displayErrorMessage('PeopleService Unavailable');
                this.isPageLoading = false;
            }
        });
    }
}
